import React, { useEffect } from 'react';

function TodoListView({
	selected,
	REF_TYPE_LABEL,
	onEditMode,
	onOpenOriginal,
	onStatusToggle,
	onDelete,
	isComplete,
	loading
}) {
	useEffect(() => {
		// (불필요한 콘솔 출력 제거)
	}, [selected]);
	if (!selected) {
		return (
			<div className="todo-detail-empty">
				왼쪽 목록에서 To-Do를 선택하세요.
			</div>
		);
	}

	// 오늘 날짜 (yyyy-mm-dd)
	const todayStr = new Date().toISOString().slice(0, 10);
	const isOverdue =
		selected.status === 'incomplete' &&
		selected.due_date &&
		selected.due_date < todayStr;

	// 날짜를 KST(한국시간)로 변환해서 yyyy-MM-dd HH:mm 형식으로 반환
	function formatKST(dateStr) {
		if (!dateStr) return '-';
		const date = new Date(dateStr);
		if (isNaN(date)) return '-';
		// yyyy-MM-dd HH:mm
		const yyyy = date.getFullYear();
		const mm = String(date.getMonth() + 1).padStart(2, '0');
		const dd = String(date.getDate()).padStart(2, '0');
		const hh = String(date.getHours()).padStart(2, '0');
		const min = String(date.getMinutes()).padStart(2, '0');
		return `${yyyy}-${mm}-${dd} ${hh}:${min}`;
	}

	return (
		<div className="todo-detail-card">
			{/* 상단 버튼 그룹 - 원본보기 왼쪽, 나머지 오른쪽 */}
			<div className="todo-top-actions" style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', gap: 8 }}>
				<div style={{ display: 'flex', alignItems: 'center', width: '100%' }}>
					<span style={{ fontSize: 22, fontWeight: 700, color: '#1f2937', marginRight: 20, whiteSpace: 'nowrap' }}>To-Do 조회</span>
					<div style={{ display: 'flex', gap: 8, flex: 1, justifyContent: 'flex-end' }}>
						<button className="btn btn-sm btn-outline-info" onClick={onOpenOriginal}>원본보기</button>
						<button className="btn btn-sm btn-outline-primary" onClick={() => onEditMode(true)}>수정</button>
						<button className={`btn btn-sm ${isComplete ? 'btn-outline-warning' : 'btn-outline-success'}`} onClick={onStatusToggle} disabled={loading}>
							{isComplete ? '미완료로 변경' : '완료 처리'}
						</button>
						<button className="btn btn-sm btn-outline-danger" onClick={onDelete} disabled={loading}>삭제</button>
					</div>
				</div>
			</div>
			{/* 버튼 아래 구분선 */}
			<div style={{ borderBottom: '1px solid #e0e0e0', margin: '12px 0 16px 0' }} />

			{/* 상단 프로젝트명 (PMS 전용) */}
			{selected.ref_type?.startsWith('pms_') && selected.add_title && (
				<div className="todo-layer-row" style={{ paddingBottom: 8 }}>
					<div style={{ color: '#0d6efd', fontWeight: 'bold', fontSize: 13 }}>
						[프로젝트: {selected.add_title}]
					</div>
				</div>
			)}

			{/* 상단 정보 및 상태 */}
			{(selected.reg_date || selected.completed_at) && (
				<div className="todo-layer-row" style={{ gap: 16, alignItems: 'center', minHeight: 40 }}>
					<div style={{ display: 'flex', alignItems: 'center', flex: 1, gap: 8, minHeight: 40 }}>
						<label className="todo-layer-label" style={{ minWidth: 48, height: 40, display: 'flex', alignItems: 'center', fontSize: 12, justifyContent: 'center' }}>등록일</label>
						<div style={{ minWidth: 0, flex: 1, background: '#f8f9fa', color: '#222', fontSize: 12, fontWeight: 500, lineHeight: '20px', padding: '0 8px', borderRadius: 4, height: 28, display: 'flex', alignItems: 'center' }}>
							{formatKST(selected.reg_date)}
						</div>
					</div>
					{selected.completed_at && (
						<div style={{ display: 'flex', alignItems: 'center', flex: 1, gap: 8, minHeight: 40 }}>
							<label className="todo-layer-label" style={{ minWidth: 48, height: 40, display: 'flex', alignItems: 'center', fontSize: 12, justifyContent: 'center' }}>완료일</label>
							<div style={{ minWidth: 0, flex: 1, background: '#f8f9fa', color: '#222', fontSize: 12, fontWeight: 500, lineHeight: '20px', padding: '0 8px', borderRadius: 4, height: 28, display: 'flex', alignItems: 'center' }}>
								{formatKST(selected.completed_at)}
							</div>
						</div>
					)}
				</div>
			)}

			{/* 제목, 상태 */}
			<div className="todo-layer-row" style={{ alignItems: 'center', minHeight: 40 }}>
				<label className="todo-layer-label" style={{ display: 'flex', alignItems: 'center', height: 40, fontSize: 12, justifyContent: 'center' }}>
					{(() => {
						if (selected.ref_type === 'pms_feed') return '제목';
						if (selected.ref_type?.startsWith('pms_')) return '상세항목';
						return '제목';
					})()}
				</label>
				<div style={{ flex: 1, display: 'flex', alignItems: 'center', minWidth: 0, height: 40 }}>
					<div
						style={{
							background: '#f8f9fa',
							flex: '1 1 0',
							minWidth: 0,
							maxWidth: 700,
							width: '100%',
							whiteSpace: 'nowrap',
							overflow: 'hidden',
							textOverflow: 'ellipsis',
							color: '#222',
							fontSize: 12,
							fontWeight: 500,
							lineHeight: '20px',
							padding: '0 8px',
							borderRadius: 4,
							height: 20,
							display: 'block',
						}}
						title={selected.title}
					>
						{selected.title}
					</div>
					<span className={`badge ${isComplete ? 'bg-success' : 'bg-warning text-dark'}`} style={{ marginLeft: 8, flexShrink: 0 }}>
						{isComplete ? '완료' : '미완료'}
					</span>
				</div>
			</div>

			{/* 등록구분/중요도 */}
			<div className="todo-layer-row" style={{ display: 'flex', alignItems: 'center', minHeight: 40, gap: 16 }}>
				{/* 등록구분(왼쪽) 복원 */}
				<div style={{ flex: 1, display: 'flex', alignItems: 'center', gap: 8, minWidth: 0, minHeight: 40 }}>
					<label className="todo-layer-label" style={{ display: 'flex', alignItems: 'center', height: 40, fontSize: 12, justifyContent: 'center' }}>등록구분</label>
					<div style={{ background: '#f8f9fa', color: '#222', fontSize: 12, fontWeight: 500, lineHeight: '20px', padding: '0 8px', borderRadius: 4, height: 28, display: 'flex', alignItems: 'center', minWidth: 0, flex: 1 }}>{REF_TYPE_LABEL[selected.ref_type] || selected.ref_type}</div>
				</div>
				{/* 중요도(오른쪽) */}
				<div style={{ flex: 1, display: 'flex', alignItems: 'center', gap: 8, minWidth: 0, minHeight: 40 }}>
					<label className="todo-layer-label" style={{ fontSize: 12, display: 'flex', alignItems: 'center', height: 40, justifyContent: 'center' }}>중요도</label>
					<div className="todo-layer-chip-group" style={{ display: 'flex', gap: 6, alignItems: 'center', height: 40, minHeight: 40 }}>
						{[
							{ value: 'high', label: '높음' },
							{ value: 'normal', label: '보통' },
							{ value: 'low', label: '낮음' },
						].map(opt => {
							let chipClass = `todo-layer-chip todo-layer-chip--priority-${opt.value}`;
							if (selected.priority === opt.value) chipClass += ' active';
							return (
								<span
									key={opt.value}
									className={chipClass}
									style={{
										display: 'inline-flex', alignItems: 'center', justifyContent: 'center', height: 32, minWidth: 36, fontSize: 12, fontWeight: 500, verticalAlign: 'middle',
										background: selected.priority === opt.value ? '#198754' : '#e9ecef',
										color: selected.priority === opt.value ? '#fff' : '#222',
										border: 'none',
										cursor: 'default',
										userSelect: 'none',
										boxShadow: 'none',
										pointerEvents: 'none',
										padding: '0 8px',
									}}
								>
									{opt.label}
								</span>
							);
						})}
					</div>
				</div>
			</div>

			{/* 기한 칩들과 날짜(라벨+값)를 한 줄에 모두 표시 */}
			<div className="todo-layer-row todo-layer-row--chips" style={{ alignItems: 'center', gap: 8, minHeight: 40 }}>
				<label className="todo-layer-label" style={{ fontSize: 12, height: 40, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>기한</label>
				<div className="todo-layer-chip-group" style={{ display: 'flex', gap: 6, alignItems: 'center', height: 32 }}>
					{[
						{ value: 'none', label: '기한 없음' },
						{ value: 'today', label: '오늘' },
						{ value: 'tomorrow', label: '내일' },
						{ value: 'custom', label: '날짜 선택' },
					].map(opt => {
						let chipClass = 'todo-layer-chip';
						if (selected.due_type === opt.value) chipClass += ' active';
						return (
							<span
								key={opt.value}
								className={chipClass}
								style={{
									display: 'inline-flex', alignItems: 'center', justifyContent: 'center', height: 32, minWidth: 36, fontSize: 12, fontWeight: 500, verticalAlign: 'middle',
									background: selected.due_type === opt.value ? '#198754' : '#e9ecef',
									color: selected.due_type === opt.value ? '#fff' : '#222',
									border: 'none',
									cursor: 'default',
									userSelect: 'none',
									boxShadow: 'none',
									pointerEvents: 'none',
									padding: '0 8px',
								}}
							>
								{opt.label}
							</span>
						);
					})}
				</div>
				{/* 날짜: 기한 없음이 아니면 라벨+값+기한지남 한 줄에 */}
				{selected.due_type !== 'none' && (
					<div style={{ display: 'flex', alignItems: 'center', gap: 4, marginLeft: 12, minHeight: 40, flex: 1 }}>
						<label className="todo-layer-label" style={{ fontSize: 12, minWidth: 28, height: 40, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>날짜</label>
						<div style={{ minWidth: 0, width: 110, background: '#f8f9fa', color: '#222', fontSize: 12, fontWeight: 500, lineHeight: '20px', padding: '0 8px', borderRadius: 4, height: 28, display: 'flex', alignItems: 'center' }}>
							{selected.due_date || '-'}
						</div>
						<div style={{ flex: 1, display: 'flex', justifyContent: 'flex-end' }}>
							{isOverdue && (
								<span style={{ color: '#d32f2f', fontWeight: 700, fontSize: 12, background: '#ffeaea', borderRadius: 4, padding: '2px 10px', height: 24, display: 'flex', alignItems: 'center', marginLeft: 8 }}>
									[기한지남]
								</span>
							)}
						</div>
					</div>
				)}
			</div>

			{/* 메모 */}
			<div className="todo-layer-row" style={{ minHeight: 40, alignItems: 'center' }}>
				<label className="todo-layer-label" style={{ fontSize: 12, height: 40, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>메모</label>
				<div className="form-control form-control-sm" style={{ background: '#f8f9fa', height: 100, overflowY: 'auto', whiteSpace: 'pre-line', fontSize: 12 }}>
					{selected.memo ? <span style={{ fontSize: 12 }}>{selected.memo}</span> : null}
				</div>
			</div>
		</div>
	);
}

export default TodoListView;
